import { render, staticRenderFns } from "./add-update-resource-action.vue?vue&type=template&id=a7df9a5c&scoped=true&"
import script from "./add-update-resource-action.vue?vue&type=script&lang=js&"
export * from "./add-update-resource-action.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7df9a5c",
  null
  
)

export default component.exports